import { render, staticRenderFns } from "./UpdateSchedaModal.vue?vue&type=template&id=6e07e654&scoped=true&"
import script from "./UpdateSchedaModal.vue?vue&type=script&lang=js&"
export * from "./UpdateSchedaModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSchedaModal.vue?vue&type=style&index=0&id=6e07e654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07e654",
  null
  
)

export default component.exports